{
  "cycle.entite.pieces_preuve": "Pièces de preuve des essais",
  "journalAudit.action.test.evidence_uploaded": "Pièce de preuve téléversée",
  "journalAudit.action.test_plan.published": "Version de plan de test publiée"
}
